<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.permissao"
            :disabled-button-search="true"
            search-by="unidadeNomeFantasia"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="$refs.ModalGrupo.open(item)"
                    authorize="storePermissoes-almoxarifado-requisicao-pendente-permissao"
                    color="primary"
                    small
                    title="Configurar permissões"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalGrupo ref="ModalGrupo" />
    </div>
</template>

<script>
// Components.
import ModalGrupo from './components/grupo/Modal'

// Others.
import { repository } from '@/mixins'

export default {
    components: { ModalGrupo },
    computed: {
        fields() {

            return [
                {
                    key: 'cnes',
                    name: 'unidade.cnes',
                    label: 'CNES',
                    class: 'col-min',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'unidadeNomeFantasia',
                    name: 'unidade.nomeFantasia',
                    label: 'Unidade',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'infraestruturaNome',
                    name: 'infraestrutura.nome',
                    label: 'Local de atendimento',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'setorNome',
                    name: 'setor.nome',
                    label: 'Setor',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    created() {

        this.repositories = {
            permissao: this.getConectaSusRepository('almoxarifado.requisicaoPendentePermissao.permissao')
        }
    },
    methods: {
        async validate() {

            return true
        }
    },
    mixins: [repository]
}
</script>